"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Loadable = require("react-loadable");
function $Loadable(relativePath, importLoader, moduleIds) {
    return Loadable({
        loader: importLoader,
        loading: function () { return null; },
        render: function (loadedLoadable, propsLoadable) {
            var arrayOfPath = relativePath.split('/');
            var name = arrayOfPath[arrayOfPath.length - 1];
            var Component = loadedLoadable[name];
            return React.createElement(Component, tslib_1.__assign({}, propsLoadable));
        },
        modules: [relativePath],
        webpack: moduleIds
    });
}
exports.Loadable = $Loadable;
//# sourceMappingURL=loadable.js.map